import { useAtom } from '@reatom/npm-react';
import { useMappedObservable } from './useMappedObservable';
export function useSubscribe(o, mapData, deps) {
    const mapped = useMappedObservable((ctx) => {
        if (typeof o === 'function') {
            return o(ctx);
        }
        const value = ctx.spy(o);
        return mapData ? mapData(value) : value;
    }, deps);
    const [value] = useAtom(mapped.__INTERNAL_DO_NOT_USE_ATOM__, deps ?? []);
    return value;
}
export function useSubscribeCb(map, deps) {
    const mapped = useMappedObservable((ctx) => map(ctx), deps);
    const [value] = useAtom(mapped.__INTERNAL_DO_NOT_USE_ATOM__, deps ?? []);
    return value;
}
